import { Box, Stack, Step, StepLabel, Stepper } from "@mui/material";
import StepWizard from "react-step-wizard";
import CustomerInformation from './CustomerInformation';
import DeliveryInformation from './DeliveryInformation';
import Summary from './Summary';

let custom = {
  enterRight: 'animated fadeIn',
  enterLeft : 'animated fadeIn',
  exitRight : 'animated fadeOut',
  exitLeft  : 'animated fadeOut'
};

export default function CheckoutWizard({ reservations }) {

  const deliveryInfoRequired = reservations.filter(reservation => reservation?.reservation_items[0]?.item.item_category?.deliverable).length > 0;

  const stepsWithoutDelivery = [
    'Customer Info',
    'Summary'
  ];

  const stepsWithDelivery = [
    'Customer Info',
    'Delivery Info',
    'Summary'
  ];

  const steps = deliveryInfoRequired ? stepsWithDelivery : stepsWithoutDelivery;


  const Navigator = ({ currentStep }) => (
    <Box sx={{ width: '100%' }} mb="1rem" mt="2rem">
      <Stepper activeStep={currentStep - 1}>
        {(steps).map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );

  if(!reservations || reservations.length === 0) return <Stack>
    <Box>
      <h1>Your cart is empty</h1>
    </Box>
  </Stack>;

  return (
    <Stack>
      <Stack px={{ sm: "15%" }} >
        <StepWizard nav={<Navigator />} transitions={custom} isLazyMount>
          <CustomerInformation reservations={reservations} />
          <DeliveryInformation />
          <Summary />
        </StepWizard>
      </Stack>
    </Stack>
  );
}